import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import ReduceCorporationTaxArticle from "./pages/ReduceCorporationTaxArticle";
import SelfAssessmentArticle from "./pages/SelfAssessmentArticle";
import MakingTaxDigitalArticle from "./pages/MakingTaxDigitalArticle";
import CorporationTaxCalculator from "./pages/CorporationTaxCalculator";
import ThankYou from "./pages/ThankYou";
import StartBusinessUK2026 from "./pages/StartBusinessUK2026";

// Staying Compliant Articles
import HMRCComplianceGuideUK from "./pages/HMRCComplianceGuideUK";
import HMRCDeadlinesUK from "./pages/HMRCDeadlinesUK";
import BookkeepingComplianceUK from "./pages/BookkeepingComplianceUK";
import MakingTaxDigitalCompliance from "./pages/MakingTaxDigitalCompliance";
import VATComplianceMistakes from "./pages/VATComplianceMistakes";
import CorporationTaxCompliance from "./pages/CorporationTaxCompliance";
import SelfAssessmentCompliance from "./pages/SelfAssessmentCompliance";
import HMRCPenaltiesGuide from "./pages/HMRCPenaltiesGuide";
import RecordKeepingUK from "./pages/RecordKeepingUK";
import ComplianceChecklistUK from "./pages/ComplianceChecklistUK";
import SoleTraderVsLimitedCompany from "./pages/SoleTraderVsLimitedCompany";
import RegisterSelfEmployedUK from "./pages/RegisterSelfEmployedUK";
import StartupCostsTaxUK from "./pages/StartupCostsTaxUK";
import VATRegistrationUK from "./pages/VATRegistrationUK";
import BusinessTaxUKGuide from "./pages/BusinessTaxUKGuide";
import BusinessBankAccountUK from "./pages/BusinessBankAccountUK";
import BusinessMistakesUK from "./pages/BusinessMistakesUK";
import StartBusinessUKPillar from "./pages/StartBusinessUKPillar";
import ScaleBusinessUK from "./pages/ScaleBusinessUK";
import CashFlowManagementUK from "./pages/CashFlowManagementUK";
import TaxPlanningGrowingBusinessUK from "./pages/TaxPlanningGrowingBusinessUK";
import SalaryVsDividendsUK2026 from "./pages/SalaryVsDividendsUK2026";
import WhenToHireAccountantUK from "./pages/WhenToHireAccountantUK";
import GrowBusinessProfitablyUK from "./pages/GrowBusinessProfitablyUK";
import RevenueVsProfitUK from "./pages/RevenueVsProfitUK";
import HiringFirstEmployeeUK from "./pages/HiringFirstEmployeeUK";
import WhenToGoLimitedUK from "./pages/WhenToGoLimitedUK";
import BusinessGrowthRisksUK from "./pages/BusinessGrowthRisksUK";
import VATPlanningUK from "./pages/VATPlanningUK";
// Business Advice Articles
import ImproveCashFlowUK from "./pages/ImproveCashFlowUK";
import BusinessGrowthProblemsUK from "./pages/BusinessGrowthProblemsUK";
import PricingStrategyUK from "./pages/PricingStrategyUK";
import IncreaseProfitWithoutRevenue from "./pages/IncreaseProfitWithoutRevenue";
import FinancialHabitsBusinessOwners from "./pages/FinancialHabitsBusinessOwners";
import InvestInBusinessUK from "./pages/InvestInBusinessUK";
import FinancialStabilityBusiness from "./pages/FinancialStabilityBusiness";
import GrowthVsProfitUK from "./pages/GrowthVsProfitUK";
import StopCashLeaksUK from "./pages/StopCashLeaksUK";
import BusinessRestructuringUK from "./pages/BusinessRestructuringUK";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Cookies from "./pages/Cookies";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/about" element={<About />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/tax-deadlines-small-businesses-2026-27" element={<BlogArticle />} />
            <Route path="/blog/reduce-corporation-tax-uk" element={<ReduceCorporationTaxArticle />} />
            <Route path="/blog/self-assessment-guide-first-time" element={<SelfAssessmentArticle />} />
            <Route path="/blog/making-tax-digital-guide" element={<MakingTaxDigitalArticle />} />
            <Route path="/blog/start-business-uk-2026" element={<StartBusinessUK2026 />} />
            <Route path="/blog/sole-trader-vs-limited-company-uk" element={<SoleTraderVsLimitedCompany />} />
            <Route path="/blog/register-self-employed-uk" element={<RegisterSelfEmployedUK />} />
            <Route path="/blog/startup-costs-tax-uk" element={<StartupCostsTaxUK />} />
            <Route path="/blog/vat-registration-uk" element={<VATRegistrationUK />} />
            <Route path="/blog/business-tax-uk-guide" element={<BusinessTaxUKGuide />} />
            <Route path="/blog/business-bank-account-uk" element={<BusinessBankAccountUK />} />
            <Route path="/blog/business-mistakes-uk" element={<BusinessMistakesUK />} />
            <Route path="/blog/scale-business-uk" element={<ScaleBusinessUK />} />
            <Route path="/blog/cash-flow-management-uk" element={<CashFlowManagementUK />} />
            <Route path="/blog/tax-planning-growing-business-uk" element={<TaxPlanningGrowingBusinessUK />} />
            <Route path="/blog/salary-vs-dividends-uk-2026" element={<SalaryVsDividendsUK2026 />} />
            <Route path="/blog/when-to-hire-accountant-uk" element={<WhenToHireAccountantUK />} />
            <Route path="/blog/grow-business-profitably-uk" element={<GrowBusinessProfitablyUK />} />
            <Route path="/blog/revenue-vs-profit-uk" element={<RevenueVsProfitUK />} />
            <Route path="/blog/hiring-first-employee-uk" element={<HiringFirstEmployeeUK />} />
            <Route path="/blog/when-to-go-limited-uk" element={<WhenToGoLimitedUK />} />
            <Route path="/blog/business-growth-risks-uk" element={<BusinessGrowthRisksUK />} />
            <Route path="/blog/vat-planning-uk" element={<VATPlanningUK />} />
            
            {/* Business Advice Articles */}
            <Route path="/blog/improve-cash-flow-uk" element={<ImproveCashFlowUK />} />
            <Route path="/blog/business-growth-problems-uk" element={<BusinessGrowthProblemsUK />} />
            <Route path="/blog/pricing-strategy-uk" element={<PricingStrategyUK />} />
            <Route path="/blog/increase-profit-without-revenue" element={<IncreaseProfitWithoutRevenue />} />
            <Route path="/blog/financial-habits-business-owners" element={<FinancialHabitsBusinessOwners />} />
            <Route path="/blog/invest-in-business-uk" element={<InvestInBusinessUK />} />
            <Route path="/blog/financial-stability-business" element={<FinancialStabilityBusiness />} />
            <Route path="/blog/growth-vs-profit-uk" element={<GrowthVsProfitUK />} />
            <Route path="/blog/stop-cash-leaks-uk" element={<StopCashLeaksUK />} />
            <Route path="/blog/business-restructuring-uk" element={<BusinessRestructuringUK />} />
            
            {/* Staying Compliant Articles */}
            <Route path="/blog/hmrc-compliance-guide-uk" element={<HMRCComplianceGuideUK />} />
            <Route path="/blog/hmrc-deadlines-uk" element={<HMRCDeadlinesUK />} />
            <Route path="/blog/bookkeeping-compliance-uk" element={<BookkeepingComplianceUK />} />
            <Route path="/blog/making-tax-digital-compliance" element={<MakingTaxDigitalCompliance />} />
            <Route path="/blog/vat-compliance-mistakes" element={<VATComplianceMistakes />} />
            <Route path="/blog/corporation-tax-compliance" element={<CorporationTaxCompliance />} />
            <Route path="/blog/self-assessment-compliance" element={<SelfAssessmentCompliance />} />
            <Route path="/blog/hmrc-penalties-guide" element={<HMRCPenaltiesGuide />} />
            <Route path="/blog/record-keeping-uk" element={<RecordKeepingUK />} />
            <Route path="/blog/compliance-checklist-uk" element={<ComplianceChecklistUK />} />
            
            <Route path="/start-a-business-uk" element={<StartBusinessUKPillar />} />
            <Route path="/corporation-tax-calculator" element={<CorporationTaxCalculator />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/cookies" element={<Cookies />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
